// extracted by mini-css-extract-plugin
export default {"card":"Home_card__K4FV1"};